import { _ } from "libs";

import React from "react";
import { User } from "../types";
import { openPlayerPopup } from "../actions";
import PlayerItemMedium from "./items/player/medium";

const FriendRequest = ({ user, onAccept, onReject }: { user: User; onAccept?: Function; onReject?: Function }) => (
	<div className="buddyRequest">
		<div className="cell" onClick={() => openPlayerPopup(user.userId)}>
			<PlayerItemMedium
				name={user.fullName ? user.fullName : user.firstName + " " + user.lastName}
				meta={user.city}
				photoUrl={user.photoUrl}
			/>
		</div>
		<div className="actions">
			<button onClick={(e) => onAccept(user.userId)} className="button small outline confirmation">
				{_("friendRequest.accept")}
			</button>
			<button onClick={(e) => onReject(user.userId)} className="button small outline">
				{_("friendRequest.ignore")}
			</button>
		</div>
	</div>
);

export default FriendRequest;
